import axios from "axios";
import { DiscountData } from "../types/discounts";

const baseUrl = process.env.REACT_APP_CARS_SERVICE_BASE_URL;
const token = localStorage.getItem("token");

export const getAllDrivers = async (page: number, limit: number) => {
  let response;
  const params = {
    page: page + 1,
    limit: limit,
    //search: "",
  };
  await axios
    .get(`${baseUrl}/api/v1/drivers/documents`, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    })
    .then((res) => {
      response = res.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

export const getDriver = async (id: any) => {
  let response;
  await axios
    .get(`${baseUrl}/api/v1/drivers/documents/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      response = res.data.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

interface vtcStatusBody {
  vtcStatus: string;
  remark?: string;
}

export const updateVtcStatus = async (id: any, body: vtcStatusBody) => {
  let response: any;
  let AUTH_SERVICE_BASE_URL = process.env.REACT_APP_AUTH_SERVICE_BASE_URL;
  await axios
    .put(`${AUTH_SERVICE_BASE_URL}/auth/v1/users/update-vtc-status/${id}`, body, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      response = res;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};
